import comp from "./AssessmentIBScaleTool";
export default comp;
